import React, { Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress, Drawer, Grid, IconButton, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { AppProvider } from "../Contexts/AppContext";
import SideBar from "./SideBar";
import styles from "./AppLayout.module.scss";

/**
 * Authenticated shell: sidebar (with Microsoft-style app launcher) + main content. No top navbar.
 */
function AppLayoutInner() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const isReportBuilderPage = pathname === "/reports" || pathname.endsWith("/reports");
  const isWhatsAppInboxPage = pathname === "/whatsapp-inbox" || pathname.endsWith("/whatsapp-inbox");
  const isUnifiedInboxPage = pathname === "/unified-inbox" || pathname.endsWith("/unified-inbox");

  return (
    <Box className={styles.root}>
      {isMobile && (
        <Drawer anchor="left" open={sidebarOpen} onClose={() => setSidebarOpen(false)} classes={{ paper: styles.drawerPaper }}>
          <Box className={styles.drawerHeader}>
            <IconButton onClick={() => setSidebarOpen(false)} aria-label="Close menu">
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className={styles.drawerSidebar}>
            <SideBar />
          </Box>
        </Drawer>
      )}

      <Grid container spacing={0} className={styles.gridContainer}>
        {!isMobile && (
          <Grid item xs={12} md={2} className={`${styles.sidebarGrid} sidebar-column`}>
            <div className="sidebar-wrapper">
              <SideBar />
            </div>
          </Grid>
        )}

        <Grid item xs={12} md={isMobile ? 12 : 10} className={styles.mainContent}>
          {isMobile && (
            <Box className={styles.mobileTopBar}>
              <IconButton onClick={() => setSidebarOpen(true)} edge="start" aria-label="Open menu">
                <MenuIcon />
              </IconButton>
            </Box>
          )}
          <Box
            component="main"
            className={styles.outletWrapper}
            sx={
              (isWhatsAppInboxPage || isUnifiedInboxPage)
                ? {
                    padding: 0,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                  }
                : !isMobile && isReportBuilderPage
                  ? { paddingRight: 0 }
                  : undefined
            }
          >
            <Suspense fallback={<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}><CircularProgress /></Box>}>
              <Outlet />
            </Suspense>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default function AppLayout() {
  return (
    <AppProvider>
      <AppLayoutInner />
    </AppProvider>
  );
}
